import { Select, SelectProps } from 'antd';
import { useStateDebounce } from '@/hooks';
import { useSubGroups } from '@/core/domain/operational/SubGroups/SubGroups.hooks';

type Props = Omit<SelectProps, 'options'>;

const SubGroupsSelectField: React.FC<Props> = (props) => {
  const [queryParam, setQueryParam] = useStateDebounce<string>();
  const { data: subGroups, isFetching } = useSubGroups({
    name: queryParam,
  });

  return (
    <Select
      allowClear
      showSearch
      onSearch={setQueryParam}
      filterOption={false}
      loading={isFetching}
      style={{ width: '100%' }}
      {...props}
      options={subGroups?.data?.map((subGroup) => ({
        value: subGroup.id,
        label: subGroup.name,
      }))}
    />
  );
};

export default SubGroupsSelectField;
